import { render, staticRenderFns } from "./AbandonedCartNotificationFlow.vue?vue&type=template&id=6b7497ff&scoped=true&"
import script from "./AbandonedCartNotificationFlow.vue?vue&type=script&lang=js&"
export * from "./AbandonedCartNotificationFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7497ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7497ff')) {
      api.createRecord('6b7497ff', component.options)
    } else {
      api.reload('6b7497ff', component.options)
    }
    module.hot.accept("./AbandonedCartNotificationFlow.vue?vue&type=template&id=6b7497ff&scoped=true&", function () {
      api.rerender('6b7497ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/AbandonedCartNotification/AbandonedCartNotificationFlow.vue"
export default component.exports